import styled from "styled-components";

const ZeFieldText = styled.span`
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
`;

export default ZeFieldText;
